import { render, staticRenderFns } from "./edit-daily-allowance.vue?vue&type=template&id=6460f35c&"
import script from "./edit-daily-allowance.vue?vue&type=script&lang=js&"
export * from "./edit-daily-allowance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports